import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { NotePencil, Sparkle } from '@phosphor-icons/react';

import { notify } from '../lib/notify';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LeadNotesPanel = ({ leadId, canWrite = true }) => {
  const [notes, setNotes] = useState([]);
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);

  const load = () => axios.get(`${API}/leads/${leadId}/notes`).then((r) => setNotes(r.data.items || [])).catch(() => {});
  useEffect(() => { load(); }, [leadId]); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async () => {
    if (!draft.trim()) return;
    setSaving(true);
    try {
      await axios.post(`${API}/leads/${leadId}/notes`, { note: draft.trim() });
      setDraft('');
      load();
    } catch (e) {
      notify(e.response?.data?.detail || 'Could not save note');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="medical-card p-5" data-testid="lead-notes-section">
      <h3 className="text-lg font-semibold text-[#052A23] mb-3 flex items-center gap-2" style={{ fontFamily: 'Outfit' }}>
        <NotePencil size={18} className="text-[#00a69c]" /> Notes
      </h3>
      {canWrite && (
        <div className="flex gap-2 mb-3">
          <input
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && save()}
            placeholder="Add a note…"
            className="flex-1 text-sm px-3 py-2 rounded-lg border border-[#D5E8E4] focus:border-[#00a69c] outline-none"
            data-testid="lead-note-input"
          />
          <button onClick={save} disabled={saving || !draft.trim()} className="px-3 py-2 rounded-lg bg-[#00a69c] text-white text-sm font-semibold disabled:opacity-50" data-testid="lead-note-save-btn">
            {saving ? '…' : 'Add'}
          </button>
        </div>
      )}
      {notes.length === 0 ? (
        <p className="text-sm text-[#6D8E87]">No notes yet</p>
      ) : (
        <div className="space-y-2 max-h-72 overflow-y-auto" data-testid="lead-notes-list">
          {notes.map((n) => (
            <div key={n.id} className="p-2.5 rounded-lg bg-[#F4F9F7] border border-[#D5E8E4] text-sm" data-testid="lead-note-item">
              <p className="text-[#052A23] whitespace-pre-wrap">{n.note}</p>
              <p className="text-xs text-[#6D8E87] mt-1 flex items-center gap-1">
                {n.source === 'copilot' && <Sparkle size={11} weight="fill" className="text-emerald-600" />}
                {n.created_by_name} · {new Date(n.created_at).toLocaleString()}
                {n.source === 'copilot' && ' · via Copilot'}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
